import { Component, OnInit } from '@angular/core';
import { FiltersEmitModel, DID } from 'voxloud-types/dist/models';
import { DidsService } from 'src/app/domains/dids/services';
import { Paginated } from 'src/app/shared/paginated.model';

const PAGE_SIZE = 20;

@Component({
  selector: 'gdp-numbers-main',
  templateUrl: './numbers-main.component.html',
  styleUrls: ['./numbers-main.component.scss']
})
export class NumbersMainComponent implements OnInit {
  public filters: FiltersEmitModel;
  public dids: DID[];
  public loading = false;
  public pageSize: number;
  public page: number = 0;
  public sameFilters: boolean = true;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };

  public filtersArray = [
    {
      name: 'company.dids.dids-filters.quick-filters.filters.temporary.label',
      filters: {
        is_from_pool: 'TEMPORARY'
      }
    },
    {
      name: 'company.dids.dids-filters.quick-filters.filters.permanent.label',
      filters: {
        is_from_pool: 'PERMANENT'
      }
    },
    {
      name: 'company.dids.dids-filters.quick-filters.filters.fax.label',
      filters: {
        class: 'FAX'
      }
    }
  ]

  constructor(
    private didsService: DidsService
  ) { }

  ngOnInit() {
    this.pageSize = PAGE_SIZE;
    this.fetchDIDs(this.filters);
  }

  onFilter(filters: FiltersEmitModel) {
    this.filters = filters;
    this.fetchDIDs(filters);
  }

  public fetchDIDs(filters: FiltersEmitModel) {
    this.dids = [];
    this.loading = true;
    this.didsService.getDids(this.pagination.page, this.pageSize, filters)
      .subscribe(
        (res: Paginated<DID>) => {
          this.dids = res.content;
          this.pagination.totalPages = res.totalPages;
          this.loading = false;
        }, () => {
          this.dids = [];
          this.pagination.totalPages = 1;
          this.pagination.page = 0;
          this.loading = false;
        }
      );
  }

  selectPageSize(event: number) {
    this.pageSize = event;
    this.pagination.page = 0;
    this.fetchDIDs(this.filters);
  }

  changeCurrentPage(event: number) {
    this.pagination = {
      page: event,
      empty: this.dids.length === 0,
      totalPages: this.pagination.totalPages
    }
    this.fetchDIDs(this.filters);
  }
}
